/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Component, OnInit, EventEmitter, Output, Input} from '@angular/core';
import {Router} from '@angular/router';

import {EmGroup} from '../models/em-group';

declare var $: any;

@Component({
  selector: 'app-remove-from-group-dialog',
  templateUrl: './remove-from-group-dialog.component.html'
})
export class RemoveFromGroupDialogComponent implements OnInit {
  
  @Output()
  confirmEvent = new EventEmitter<EmGroup>();
  
  mGroups: EmGroup[] = [];
  mSelectedGroup: EmGroup = null;
  
  mItemNames: string[] = [];
  
  constructor(
    private mRouter: Router
  ) {}


  ngOnInit(): void {
    
  }
  
  show(groups: EmGroup[], itemNames: string[]): void {
    this.mGroups = groups;
    this.mSelectedGroup = this.mGroups.length > 0? this.mGroups[0] : null;
    this.mItemNames = itemNames;
    $("#remove-from-group-dialog").modal("show");
  }
  
  hide(): void {
    $("#remove-from-group-dialog").modal("hide");
  }
  
  confirm(): void {
    if (this.mSelectedGroup == null) {
      alert("A Group must be selected.");
    } else {
      this.confirmEvent.emit(this.mSelectedGroup);
      this.hide();
    }
  }

}
